<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition" :persistent="loading"
        scrollable>
        <v-card class="pa-0">
            <v-toolbar dark color="primary" class="max-h-16">
                <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ isReadonlyMode ? 'Detalhes do contrato' : (isEditMode ? 'Editar contrato' : 'Gerar contrato') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="close">
                        Fechar
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pa-0">
                <v-stepper v-model="step" class="elevation-0">
                    <v-stepper-header class="elevation-0 container">
                        <v-stepper-step :complete="step > 1" step="1">
                            Dados do Contrato
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="step > 2" step="2">
                            Conteúdo e Visualização
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1" class="pa-4 container">
                            <v-form ref="formContract">
                                <v-row>
                                    <v-col v-if="error_message" cols="12">
                                        <v-alert type="error darken-4">
                                            {{ error_message }}
                                        </v-alert>
                                    </v-col>
                                    <v-col v-if="success_message" cols="12">
                                        <v-alert type="success">
                                            {{ success_message }}
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col>
                                                <v-divider class="bg-primary-blue border-2"></v-divider>
                                            </v-col>
                                            <v-col cols="auto" class="font-bold">
                                                Informações do contrato
                                            </v-col>
                                            <v-col>
                                                <v-divider class="bg-primary-pink border-2"></v-divider>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-select v-model="service_type" label="Tipo de serviço"
                                            :readonly="isReadonlyMode" :items="select_services"
                                            :rules="[basic_rules.required]" />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-model="contractor" label="Nome do contratante"
                                            :rules="[basic_rules.required]" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field-simplemask v-model="cpf" label="CPF" :options="{
                                            inputMask: '###.###.###-##',
                                            outputMask: '###########',
                                            empty: null,
                                            applyAfter: false,
                                            alphanumeric: true,
                                            lowerCase: false,
                                        }" :properties="{
                                            rules: [basic_rules.required],
                                            readonly: isReadonlyMode
                                        }" />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-model="rg" label="RG" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col>
                                                <v-divider class="bg-primary-blue border-2"></v-divider>
                                            </v-col>
                                            <v-col cols="auto" class="font-bold">
                                                Informações do pagamento
                                            </v-col>
                                            <v-col>
                                                <v-divider class="bg-primary-pink border-2"></v-divider>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-select v-model="billing_type" label="Tipo de pagamento" :items="[
                                            { text: 'Pagamento mensal', value: 'M' },
                                            { text: 'Pagamento por atendimento', value: 'A' }
                                        ]" :rules="[basic_rules.required]" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col v-if="billing_type !== 'M'" cols="12" md="6">
                                        <v-select v-model="payment_frequency" label="Frequencia de pagamento" :items="[
                                            { text: 'Mensal', value: 'M' },
                                            { text: 'Quinzenal', value: 'Q' },
                                            { text: 'Semanal', value: 'S' }
                                        ]" :rules="[basic_rules.required]" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field-money v-model="ammount" label="Valor a ser pago" :properties="{
                                            prefix: 'R$',
                                            rules: [basic_rules.required],
                                            readonly: isReadonlyMode
                                        }" :options="{
                                            locale: 'pt-BR',
                                            length: 11,
                                            precision: 2,
                                            empty: null,
                                        }" />
                                    </v-col>
                                    <v-col :cols="billing_type !== 'M' ? 12 : 12" :md="billing_type !== 'M' ? 6 : 12">
                                        <v-menu ref="menuDatePickerPayment" v-model="show_datepicker_payment"
                                            :close-on-content-click="false" transition="scale-transition" offset-y
                                            min-width="auto" :disabled="isPaydayReadonly">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="formatDate(payday)"
                                                    label="Dia do próximo pagamento" append-icon="mdi-calendar" readonly
                                                    v-bind="attrs" v-on="on"
                                                    @input="$event => payday = formatUsa($event)"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="payday" no-title scrollable editable
                                                @input="show_datepicker_payment = false" />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field-money v-model="cancel_value"
                                            label="Taxa de cancelamento de atendimento" :properties="{
                                                prefix: 'R$',
                                                rules: [basic_rules.required],
                                                readonly: isReadonlyMode
                                            }" :options="{
                                                locale: 'pt-BR',
                                                length: 11,
                                                precision: 2,
                                                empty: null,
                                            }" />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-switch v-model="equal_payer" color="primary-blue"
                                            label="O pagador é o mesmo que o contratante?"
                                            :readonly="isReadonlyMode"></v-switch>
                                    </v-col>
                                    <v-col v-if="!equal_payer" cols="12" md="6">
                                        <v-text-field v-model="payer_name" label="Nome do pagador"
                                            :rules="!equal_payer ? [basic_rules.required] : []"
                                            :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col v-if="!equal_payer" cols="12" md="6">
                                        <v-text-field-simplemask v-model="payer_cpf" label="CPF do pagador" :options="{
                                            inputMask: '###.###.###-##',
                                            outputMask: '###########',
                                            empty: null,
                                            applyAfter: false,
                                            alphanumeric: true,
                                            lowerCase: false,
                                        }" :properties="{
                                            readonly: isReadonlyMode
                                        }" />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col>
                                                <v-divider class="bg-primary-blue border-2"></v-divider>
                                            </v-col>
                                            <v-col cols="auto" class="font-bold">
                                                Informações do atendimento
                                            </v-col>
                                            <v-col>
                                                <v-divider class="bg-primary-pink border-2"></v-divider>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-select v-model="week_day_attendance" label="Dia do atendimento" :items="[
                                            { text: 'Segunda', value: 'monday' },
                                            { text: 'Terça', value: 'tuesday' },
                                            { text: 'Quarta', value: 'wednesday' },
                                            { text: 'Quinta', value: 'thursday' },
                                            { text: 'Sexta', value: 'friday' },
                                            { text: 'Sábado', value: 'saturday' },
                                            { text: 'Domingo', value: 'sunday' }
                                        ]" :rules="[basic_rules.required]" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-menu ref="menuTimePicker" v-model="show_timepicker"
                                            :close-on-content-click="false" :return-value.sync="hour_attendance"
                                            transition="scale-transition" offset-y min-width="300px" :disabled="isReadonlyMode">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="hour_attendance" label="Hora"
                                                    append-icon="mdi-calendar" readonly :rules="[basic_rules.required]"
                                                    v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-time-picker v-if="show_timepicker" v-model="hour_attendance"
                                                format="24hr" full-width
                                                @click:minute="$refs.menuTimePicker.save(hour_attendance)" />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-select v-model="attendance_frequency" label="Frequencia" :items="[
                                            { text: 'Mensal', value: 'M' },
                                            { text: 'Quinzenal', value: 'Q' },
                                            { text: 'Semanal', value: 'S' }
                                        ]" :rules="[basic_rules.required]" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-model="attendance_duration" label="Duração (em minutos)"
                                            :rules="[basic_rules.required]" type="number" :readonly="isReadonlyMode" />
                                    </v-col>
                                    <v-col v-if="!isEditMode" cols="12" md="6">
                                        <v-menu ref="menuNextAttendance" v-model="show_next_attendance"
                                            :close-on-content-click="false" transition="scale-transition" offset-y
                                            :readonly="isReadonlyMode" min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="formatDate(next_attendance)"
                                                    label="Data do próximo atendimento" append-icon="mdi-calendar"
                                                    :rules="!isEditMode ? [basic_rules.required] : []"
                                                    :readonly="isReadonlyMode" v-bind="attrs" v-on="on"
                                                    @input="$event => next_attendance = formatUsa($event)"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="next_attendance" no-title scrollable
                                                :readonly="isReadonlyMode" editable
                                                @input="show_next_attendance = false" />
                                        </v-menu>
                                    </v-col>
                                    <v-col v-if="!isEditMode" cols="12" md="6">
                                        <v-menu ref="menuTimePickerAttendance" v-model="show_timepicker_attendance"
                                            :close-on-content-click="false" :return-value.sync="hour_next_attendance"
                                            :readonly="isReadonlyMode" transition="scale-transition" offset-y
                                            min-width="300px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="hour_next_attendance"
                                                    label="Hora do próximo atendimento" append-icon="mdi-calendar"
                                                    readonly :rules="!isEditMode ? [basic_rules.required] : []"
                                                    v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-time-picker v-if="show_timepicker_attendance"
                                                v-model="hour_next_attendance" format="24hr" full-width
                                                :readonly="isReadonlyMode"
                                                @click:minute="$refs.menuTimePickerAttendance.save(hour_next_attendance)" />
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col>
                                                <v-divider class="border-2"
                                                    style="border-image: linear-gradient(to right, #6C63FF, #A5A6F6) 1;border-top-style: solid;"></v-divider>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-menu ref="menuDatePicker" v-model="show_datepicker"
                                            :close-on-content-click="false" transition="scale-transition" offset-y
                                            :readonly="isReadonlyMode" min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="formatDate(date)" label="Data do contrato"
                                                    append-icon="mdi-calendar" :rules="[basic_rules.required]"
                                                    :readonly="isReadonlyMode" v-bind="attrs" v-on="on"
                                                    @input="$event => date = formatUsa($event)"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date" no-title scrollable editable
                                                :readonly="isReadonlyMode" @input="show_datepicker = false" />
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-stepper-content>

                        <v-stepper-content step="2" class="pa-4">
                            <v-container fluid>
                                <v-row class="fill-height mb-6">
                                    <v-col cols="12" md="6" class="d-flex flex-column">
                                        <div class="d-flex align-center mb-3">
                                            <v-icon color="primary" class="mr-2">mdi-file-edit</v-icon>
                                            <span class="text-h6 font-weight-bold">Editor</span>
                                        </div>
                                        <tip-tap-editor v-model="contract_html" :disabled="isReadonlyMode"
                                            class="flex-grow-1" />
                                    </v-col>
                                    <v-col cols="12" md="6" class="d-flex flex-column">
                                        <div class="d-flex align-center mb-3">
                                            <v-icon color="primary" class="mr-2">mdi-file-eye</v-icon>
                                            <span class="text-h6 font-weight-bold">Preview</span>
                                        </div>
                                        <v-card outlined class="pa-4 flex-grow-1 overflow-y-auto">
                                            <div class="contract-preview" v-html="previewHtml"></div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>

            <!-- Fixed Footer Actions -->
            <v-divider></v-divider>
            <v-card-actions class="pa-4">
                <v-container>
                    <v-row>
                        <v-col class="d-flex justify-space-between align-center">
                            <!-- Step 1 Actions -->
                            <template v-if="step === 1">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="nextStep">
                                    Próximo
                                    <v-icon right>mdi-arrow-right</v-icon>
                                </v-btn>
                            </template>

                            <!-- Step 2 Actions -->
                            <template v-if="step === 2">
                                <v-btn text color="primary" @click="step = 1">
                                    <v-icon left>mdi-arrow-left</v-icon>
                                    Voltar
                                </v-btn>
                                <v-btn v-if="!['C', 'E'].includes(status)" :disabled="loading" :loading="loading"
                                    color="primary" elevation="0" @click="isEditMode ? updateContract() : save()">
                                    {{ isEditMode ? 'Atualizar' : 'Gerar' }} <v-icon right>mdi-check-bold</v-icon>
                                </v-btn>
                            </template>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>


        </v-card>
    </v-dialog>
</template>

<script>
import dayjs from "dayjs";
dayjs.extend(require('dayjs/plugin/customParseFormat'));
import { mapActions, mapState } from 'vuex';
import TipTapEditor from '../../contract-templates/components/TipTapEditor.vue';
import axios from 'axios';
import extenso from 'extenso';

export default {
    components: {
        TipTapEditor
    },
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        },
        customer: {
            type: Object,
            required: false,
            default: null
        },
        contractData: {
            type: Object,
            required: false,
            default: null
        },
        countByService: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            show: this.value,
            step: 1,
            basic_rules: {
                required: value => !!value || "Informação obrigatória"
            },

            show_datepicker: false,
            show_timepicker: false,
            show_next_attendance: false,
            show_timepicker_attendance: false,
            show_datepicker_payment: false,

            status: "P",
            equal_payer: false,
            service_type: null,
            contractor: null,
            cpf: null,
            rg: null,
            billing_type: null,
            payment_frequency: null,
            ammount: null,
            payday: null,
            cancel_value: null,
            week_day_attendance: null,
            hour_attendance: null,
            attendance_frequency: null,
            attendance_duration: null,
            next_attendance: null,
            hour_next_attendance: null,
            date: null,
            payer_name: null,
            payer_cpf: null,

            loading: false,
            error_message: null,
            success_message: null,
            select_services: [],

            contract_html: "",
            week_day_description: {
                monday: 'Segunda-feira',
                tuesday: 'Terça-feira',
                wednesday: 'Quarta-feira',
                thursday: 'Quinta-feira',
                friday: 'Sexta-feira',
                saturday: 'Sábado',
                sunday: 'Domingo'
            },
            frequency_description: {
                M: "Mensal",
                Q: "Quinzenal",
                S: "Semanal"
            },
        };
    },
    computed: {
        ...mapState("services", ["services_list"]),
        ...mapState("contractTemplates", ["current_template"]),
        ...mapState("auth", ["user"]),
        isEditMode() {
            return this.contractData && Object.keys(this.contractData).length > 0;
        },
        isReadonlyMode() {
            return this.contractData && this.contractData.status !== 'P';
        },
        isPaydayReadonly() {
            return this.contractData && ['C', 'E'].includes(this.contractData.status);
        },
        previewHtml() {
            let html = this.contract_html;
            if (!html) return "";

            html = html.replaceAll('[CONTRACTOR]', this.contractor || "__________________________");
            html = html.replaceAll('[CPF]', this.cpf ? this.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "___.___.___-__");
            html = html.replaceAll('[RG]', this.rg);

            html = html.replaceAll('[MINUTES]', this.attendance_duration || "___");
            html = html.replaceAll('[WEEKDAY]', this.week_day_attendance ? this.week_day_description[this.week_day_attendance] : "__________");
            html = html.replaceAll('[HOUR]', this.hour_attendance || "__:__");
            html = html.replaceAll('[FREQUENCY]', this.attendance_frequency ? this.frequency_description[this.attendance_frequency] : "__________");

            let value = this.ammount ? (Number.isInteger(this.ammount) ? this.ammount : parseFloat(this.ammount.toString().replace(/[^0-9.]+/g, ""))) : 0;
            html = html.replaceAll('[VALUE]', value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            html = html.replaceAll('[FULL_VALUE]', value ? extenso(value.toLocaleString('pt-BR'), { mode: 'currency' }) : "__________");

            html = html.replaceAll('[PAYMENT_TYPE]', this.billing_type === 'A' ? 'Por atendimento' : 'Mensal');

            let cancelValue = this.cancel_value ? (Number.isInteger(this.cancel_value) ? this.cancel_value : parseFloat(this.cancel_value.toString().replace(/[^0-9.]+/g, ""))) : 0;
            html = html.replaceAll('[CANCEL_VALUE]', cancelValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));

            html = html.replaceAll('[DATE]', this.date ? dayjs(this.date).format('DD [de] MMMM [de] YYYY') : "___ de __________ de ____");

            // Novas variáveis do sistema de templates
            html = html.replaceAll('[PAYER_NAME]', this.payer_name || this.contractor || "__________________________");
            html = html.replaceAll('[PAYER_CPF]', this.payer_cpf ? this.payer_cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : (this.cpf ? this.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "___.___.___-__"));
            html = html.replaceAll('[SERVICE_NAME]', this.getServiceName() || "__________");
            html = html.replaceAll('[PAYMENT_FREQUENCY]', this.payment_frequency ? this.frequency_description[this.payment_frequency] : "__________");
            html = html.replaceAll('[PAYDAY]', this.payday || "__");
            html = html.replaceAll('[NEXT_ATTENDANCE]', this.next_attendance ? dayjs(this.next_attendance).format('DD/MM/YYYY') : "__/__/____");
            html = html.replaceAll('[NEXT_ATTENDANCE_HOUR]', this.hour_next_attendance || "__:__");
            html = html.replaceAll('[DOCTOR_NAME]', this.user.name);
            html = html.replaceAll('[DOCTOR_EMAIL]', this.user.email);
            html = html.replaceAll('[DOCTOR_PHONE]', this.user.phone);
            html = html.replaceAll('[DOCTOR_CRP]', this.user.crp);
            html = html.replaceAll('[DOCTOR_CPF]', this.user.cpf);
            html = html.replaceAll('[DOCTOR_RG]', this.user.rg);
            html = html.replaceAll('[DOCTOR_ADDRESS]', this.user.address);

            return html;
        }
    },
    watch: {
        value() {
            this.show = this.value;
        },
        contractData: {
            handler(newData) {
                if (newData && Object.keys(newData).length > 0) {
                    this.fillFormWithContractData(newData);
                }
            },
            immediate: true
        },
        show() {
            if (!this.show) {
                this.cleanupForm();
                this.$emit("close");
            } else {
                if (!this.isEditMode) {
                    this.cleanupForm();
                    if (this.customer) {
                        this.fillCustomerData();
                    }
                    this.getServices();
                    this.mountSelectServices();
                    this.loadDefaultContract();
                } else {
                    // Edit mode: services still need to be loaded for the select field,
                    // but do NOT call loadDefaultContract() as it would overwrite the saved html_content
                    this.getServices();
                    this.mountSelectServices();
                }
            }

            this.loading = false;
            this.error_message = null;
            this.success_message = null;
            this.$emit("input", this.show);
        },
        customer() {
            if (this.show && this.customer && !this.isEditMode) {
                this.fillCustomerData();
            }
        },
        services_list() {
            this.mountSelectServices();
        },
        service_type(newValue, oldValue) {
            // Só carrega se mudou e não está em modo de edição
            if (newValue && newValue !== oldValue && !this.isEditMode) {
                this.loadDefaultContract();
            }
        }
    },
    methods: {
        ...mapActions("customers", ["ActionDoGenerateContract", "ActionDoUpdateContract"]),
        ...mapActions("services", ["ActionDoGetServices"]),
        ...mapActions("contractTemplates", ["ActionDoGetContractTemplateByService"]),
        nextStep() {
            if (this.$refs.formContract.validate()) {
                this.step = 2;
            }
        },
        async loadDefaultContract() {
            // Se tem service_type selecionado, tenta carregar template via Vuex action
            if (this.service_type) {
                try {
                    await this.ActionDoGetContractTemplateByService(this.service_type);

                    // Se encontrou template, usa o conteúdo
                    if (this.current_template && this.current_template.template_content) {
                        this.contract_html = this.current_template.template_content;
                        return;
                    }
                } catch (error) {
                    console.log("Template não encontrado, usando padrão legado", error);
                }
            }

            // Fallback para HTML legado
            try {
                const response = await axios.get('/contract/contract.html');
                this.contract_html = response.data;
            } catch (error) {
                console.error("Erro ao carregar contrato padrão", error);
            }
        },
        fillFormWithContractData(data) {
            this.status = data.status || "P";
            this.equal_payer = data.same_payer;
            this.service_type = data.service_id;
            this.contractor = data.contractor;
            this.cpf = data.cpf;
            this.rg = data.rg;
            this.billing_type = data.billing_type;
            this.payment_frequency = data.payment_frequency;
            this.ammount = data.attendance_value / 100;
            this.payday = data.payday;
            this.cancel_value = data.cancel_value / 100;
            this.week_day_attendance = data.week_day_attendance;
            this.hour_attendance = data.hour_attendance;
            this.attendance_frequency = data.attendance_frequency;
            this.attendance_duration = data.attendance_duration;
            this.next_attendance = data.next_attendance;
            this.hour_next_attendance = data.hour_next_attendance;
            this.date = data.date;
            this.payer_name = data.payer_name;
            this.payer_cpf = data.payer_cpf;
            this.contract_html = data.html_content || "";
        },
        cleanupForm() {
            this.step = 1;
            this.show_datepicker = false;
            this.show_timepicker = false;
            this.show_next_attendance = false;
            this.show_timepicker_attendance = false;
            this.show_datepicker_payment = false;

            this.status = "P";
            this.equal_payer = false;
            this.service_type = null;
            this.contractor = null;
            this.cpf = null;
            this.rg = null;
            this.billing_type = null;
            this.payment_frequency = null;
            this.ammount = null;
            this.payday = null;
            this.cancel_value = null;
            this.week_day_attendance = null;
            this.hour_attendance = null;
            this.attendance_frequency = null;
            this.attendance_duration = null;
            this.next_attendance = null;
            this.hour_next_attendance = null;
            this.date = null;
            this.payer_name = null;
            this.payer_cpf = null;
            this.contract_html = "";
            
            if (this.$refs.formContract) {
                this.$refs.formContract.resetValidation();
            }
        },
        fillCustomerData() {
            this.contractor = this.customer.name;
            this.cpf = this.customer.cpf;
            this.rg = this.customer.rg;
            this.cancel_value = 20;
            this.date = dayjs().format('YYYY-MM-DD');
        },
        close() {
            this.show = false;
        },
        formatDate(date) {
            return date ? dayjs(date).format("DD/MM/YYYY") : null;
        },
        formatUsa(date) {
            if (date) {
                if (date.length === 8) {
                    return dayjs(date, 'DDMMYYYY').format('YYYY-MM-DD');
                } else if (date.length === 10) {
                    return dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            }

            return null;
        },
        mountSelectServices() {
            if (this.services_list && this.services_list.length > 0) {
                this.select_services = this.services_list.map(service => ({
                    text: service.name,
                    value: service.id,
                    disabled: (this.isEditMode && this.contractData.service_id === service.id ? false : (this.countByService && this.countByService[service.id] > 0))
                }));
            } else {
                this.select_services = [];
            }
        },
        getServices() {
            if (!this.services_list || this.services_list.length === 0) {
                this.ActionDoGetServices();
            }
        },
        getServiceName() {
            const service = this.select_services.find(s => s.value === this.service_type);
            return service ? service.text : '';
        },
        save() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;

            if (this.$refs.formContract.validate()) {
                this.ActionDoGenerateContract({
                    service_id: this.service_type,
                    contractor: this.contractor,
                    cpf: this.cpf,
                    rg: this.rg,
                    billing_type: this.billing_type,
                    payment_frequency: this.billing_type === 'M' ? 'M' : this.payment_frequency,
                    ammount: Number.isInteger(this.ammount) ? this.ammount * 100 : parseInt(this.ammount.toString().replace(/[^0-9]+/g, "")),
                    payday: this.payday,
                    cancel_value: Number.isInteger(this.cancel_value) ? this.cancel_value * 100 : parseInt(this.cancel_value.toString().replace(/[^0-9]+/g, "")),
                    week_day_attendance: this.week_day_attendance,
                    hour_attendance: this.hour_attendance,
                    attendance_frequency: this.attendance_frequency,
                    attendance_duration: this.attendance_duration,
                    next_attendance: this.next_attendance,
                    hour_next_attendance: this.hour_next_attendance,
                    date: this.date,
                    same_payer: this.equal_payer,
                    payer_name: this.payer_name,
                    payer_cpf: this.payer_cpf,
                    customer_id: this.customer.id,
                    html_content: this.contract_html
                }).then(response => {
                    if (response.contract) {
                        this.success_message = "Contrato cadastrado com sucesso";
                        this.$refs.formContract.reset();
                        this.loading = false;
                        this.$emit("created");
                        this.show = false;
                    } else {
                        this.error_message = "Houve um erro ao cadastrar o contrato";
                        this.loading = false;
                    }
                }).catch(error => {
                    console.error(error);
                    this.error_message = error.response.data;
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        },
        updateContract() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;

            if (this.$refs.formContract.validate()) {
                this.ActionDoUpdateContract({
                    contract_id: this.contractData.id,
                    service_id: this.service_type,
                    contractor: this.contractor,
                    cpf: this.cpf,
                    rg: this.rg,
                    billing_type: this.billing_type,
                    payment_frequency: this.billing_type === 'M' ? 'M' : this.payment_frequency,
                    ammount: Number.isInteger(this.ammount) ? this.ammount * 100 : parseInt(this.ammount.toString().replace(/[^0-9]+/g, "")),
                    payday: this.payday,
                    cancel_value: Number.isInteger(this.cancel_value) ? this.cancel_value * 100 : parseInt(this.cancel_value.toString().replace(/[^0-9]+/g, "")),
                    week_day_attendance: this.week_day_attendance,
                    hour_attendance: this.hour_attendance,
                    attendance_frequency: this.attendance_frequency,
                    attendance_duration: this.attendance_duration,
                    date: this.date,
                    same_payer: this.equal_payer,
                    payer_name: this.payer_name,
                    payer_cpf: this.payer_cpf,
                    html_content: this.contract_html
                }).then(response => {
                    if (response.contract) {
                        this.success_message = "Contrato atualizado com sucesso";
                        this.$refs.formContract.reset();
                        this.loading = false;
                        this.$emit("created");
                        this.show = false;
                    } else {
                        this.error_message = "Houve um erro ao atualizar o contrato";
                        this.loading = false;
                    }
                }).catch(error => {
                    console.error(error);
                    this.error_message = error.response.data;
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        },

        pickColor() {
            if (!window.EyeDropper) {
                this.error_message = "Seu navegador não suporta a ferramenta conta-gotas.";
                return;
            }

            const eyeDropper = new window.EyeDropper();
            eyeDropper.open().then((result) => {
                this.currentColor = { hex: result.sRGBHex };
            }).catch((e) => {
                console.log("Eyedropper cancelled or failed", e);
            });
        }
    },
    mounted() {
        this.getServices();
        this.mountSelectServices();
    }
};
</script>

<style scoped>
/* Contract preview container */
.contract-preview {
    width: 100%;
}

/* Force inline styles to work - highest priority */
::v-deep .contract-preview [style*="text-align: center"],
::v-deep .contract-preview [style*="text-align:center"] {
    text-align: center !important;
}

::v-deep .contract-preview [style*="text-align: right"],
::v-deep .contract-preview [style*="text-align:right"] {
    text-align: right !important;
}

::v-deep .contract-preview [style*="text-align: justify"],
::v-deep .contract-preview [style*="text-align:justify"] {
    text-align: justify !important;
}

::v-deep .contract-preview [style*="text-align: left"],
::v-deep .contract-preview [style*="text-align:left"] {
    text-align: left !important;
}

/* Preserve text alignment from editor in preview */
::v-deep .contract-preview p,
::v-deep .contract-preview h1,
::v-deep .contract-preview h2,
::v-deep .contract-preview h3,
::v-deep .contract-preview h4,
::v-deep .contract-preview h5,
::v-deep .contract-preview h6 {
    margin-bottom: 1em;
}

/* Override Tailwind CSS reset - restore heading sizes */
::v-deep .contract-preview h1 {
    font-size: 2em !important;
    font-weight: normal !important;
    line-height: 1.2 !important;
}

::v-deep .contract-preview h2 {
    font-size: 1.5em !important;
    font-weight: normal !important;
    line-height: 1.3 !important;
}

::v-deep .contract-preview h3 {
    font-size: 1.17em !important;
    font-weight: normal !important;
    line-height: 1.4 !important;
}

::v-deep .contract-preview h4 {
    font-size: 1em !important;
    font-weight: normal !important;
    line-height: 1.4 !important;
}

::v-deep .contract-preview h5 {
    font-size: 0.83em !important;
    font-weight: normal !important;
    line-height: 1.5 !important;
}

::v-deep .contract-preview h6 {
    font-size: 0.67em !important;
    font-weight: normal !important;
    line-height: 1.5 !important;
}

/* Ensure Quill alignment classes work in preview */
::v-deep .contract-preview .ql-align-center {
    text-align: center !important;
}

::v-deep .contract-preview .ql-align-right {
    text-align: right !important;
}

::v-deep .contract-preview .ql-align-justify {
    text-align: justify !important;
}

::v-deep .contract-preview .ql-align-left {
    text-align: left !important;
}

/* Quill font size classes */
::v-deep .contract-preview .ql-size-small {
    font-size: 0.75em !important;
}

::v-deep .contract-preview .ql-size-large {
    font-size: 1.5em !important;
}

::v-deep .contract-preview .ql-size-huge {
    font-size: 2.5em !important;
}

/* Quill font family classes */
::v-deep .contract-preview .ql-font-serif {
    font-family: Georgia, Times New Roman, serif !important;
}

::v-deep .contract-preview .ql-font-monospace {
    font-family: Monaco, Courier New, monospace !important;
}
</style>
